import { MediaMatcher } from '@angular/cdk/layout';
import { NavigationStart, Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  OnInit
} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { CommonService } from '../../shared/common.service';

import { StreamService } from '../../shared/stream.service';

declare var $: any;
/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.component.scss'],
  // animations: [
  //   trigger('routerTransition', [
  //     transition('* <=> *', [    
  //       query(':enter, :leave', style({ position: 'fixed', opacity: 0 }),{ optional: true }),
  //       group([ 
  //         query(':enter', [
  //           style({ opacity:0 }),
  //           animate('600ms ease-in-out', style({ opacity:0 })),

  //         ],{ optional: true }),
  //         query(':leave', [
  //           style({ opacity:0.5 }),
  //           animate('600ms ease-in-out', style({ opacity:0 }))],{ optional: true }),
  //       ])
  //     ])
  //   ])
  //  ]
})
export class FullComponent implements OnDestroy, AfterViewInit,OnInit {
  mobileQuery: MediaQueryList;
  isMenuOpen = true;
  contentMargin: number ;
  activeIndex:any;
  message: number;
  public screenWidth: any;
  public screenHeight: any;
  isMobile: boolean = false;
  detail:any;
  Name:string;
  routeName:string;
  profilePic:string;
  headerTitle = [];
  userData:any;
  userRole:any
  showScroll : boolean = true;
  isLoading:boolean = false;
  isPodcast:boolean = false;
  NoScroll =["Search","My Matches","My Favorites"];
  currentScreenWidth:any;
  currentNavition:any;
  adminFilterAccess:[2,3,4,5]
  private _mobileQueryListener: () => void;
  
  mainMenuItems = [
    { state: 'dashboard', name: 'Dashboard', iconUrl:"assets/images/dashboard.svg", type: 'link', iconUrlActive:'assets/images/dashboard-white.svg'},
    { state: 'user', name: 'Members', iconUrl:"assets/images/users.svg", type: 'link', iconUrlActive:'assets/images/users-white.svg'},
    { state: 'concierge', name: 'Concierge', iconUrl:"assets/images/consigne.svg.svg", type: 'link', iconUrlActive:'assets/images/consigne.svg'},
    // { state: 'staff', name: 'Staff', iconUrl:"assets/images/staff.svg", type: 'link', iconUrlActive:'assets/images/staff.svg'},
    { state: 'service', name: 'Services', iconUrl:"assets/images/service.svg", type: 'link', iconUrlActive:'assets/images/service-white.svg'},
    { state: 'service/service-list-emergency', name: 'Urgent Services', iconUrl:"assets/images/urgent.svg", type: 'link', iconUrlActive:'assets/images/urgent.svg'},
    { state: 'space/space-list', name: 'Space', iconUrl:"assets/images/room.svg", type: 'link', iconUrlActive:'assets/images/room-white.svg'},
    { state: 'bookings', name: 'Bookings', iconUrl:"assets/images/booking.svg", type: 'link', iconUrlActive:'assets/images/booking-white.svg'},
    { state: 'events', name: 'Events', iconUrl:"assets/images/event.svg", type: 'link', iconUrlActive:'assets/images/event-white.svg'}
    
  ];


  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public common :CommonService,
    public router :Router,
    private streamService: StreamService

  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url.startsWith('/main/')) {
          this.message = parseInt(localStorage.getItem('activeIndex'));
          this.getHeader();
        }
      }
    });
     this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

  }

  ngOnInit() {
    this.activeIndex = localStorage.getItem("activeIndex")
    this.userRole = localStorage.getItem("role")
    this.userData = this.common.getUser();
    if (this.userData.userType =='admin') {
      this.currentNavition = this.mainMenuItems;
    }
    
    this.message = parseInt(localStorage.getItem('activeIndex'));
    this.getHeader();
    this.streamService.getSubscription().subscribe(message => {
      this.message = message.data;
      this.getHeader();
    });

  
    $(".rotate").click(function () {
      $(this).toggleClass("down");
  })
  this.currentScreenWidth = screen.width ;
  if( this.currentScreenWidth <=  780) {
    this.isMobile = true;
  }
  }
  navName:string;
  getHeader() {
    this.headerTitle = this.currentNavition;
    this.navName  = this.headerTitle[this.message].name;
  };
  // checkFilterAccessValidation() {
  //   if(this.userData.role = 'admin') {
  //     for(let i =0; i < this.adminFilterAccess.length; i++) {
       
  //     }

  //   }
  
  // }
changePasswordNav() {
  // this.checkFilterAccessValidation()

if(this.userData.role =='manager') {
  localStorage.setItem("activeIndex",'5')
  this.getHeader()

  this.router.navigate(["/main/manager/change-password"]) 
} 
if(this.userData.role =='employee') {
  localStorage.setItem("activeIndex",'3')
  this.getHeader()
  this.router.navigate(["/main/employee/change-password"]) 
}
if(this.userData.role =='admin') {
  localStorage.setItem("activeIndex",'10')
  this.getHeader()
  this.router.navigate(["/main/admin/change-password"]) 
}
}

  logoutUser() { 
    this.common.logOut();
}

  // navigateSroll() {
  //   this.showScroll = this.NoScroll.indexOf(this.headerTitle) == -1;
  // }


  WindowResize(e) {
    // setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 260);
    }

    ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  readLocalStorageValue(key: string): number {
    return parseInt(localStorage.getItem(key));
  }
  logOut() {
    this.common.logOut();
  }
  ngAfterViewInit() {}

  onSidebarMenuClick(event: Event, snav: any) {
    if(this.isMobile == true) {
      snav.toggle();
      this.WindowResize(event);
    }
  
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    if( this.screenWidth <= 780) {
      this.isMobile = true;
      
    }
    else {
      this.isMobile =false;
    }
  }
}
